export default __webpack_public_path__ + "a27a8d7175cbd8a866a3e08b6f2afacd.png";